import React from "react";
import DataGrid from './data-grid';
export default class UtmActivityGrid extends React.Component {
  render() {
    var data = this.props.data;
    var columns = [{
      field: 'source',
      title: 'Source',
      cell: props => {
        var row = props.dataItem;
        return /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
          className: "grid-ellipsis pointer",
          title: row.source
        }, row.source));
      }
    }, {
      field: 'medium',
      title: 'Medium',
      cell: props => {
        var row = props.dataItem;
        return /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
          className: "grid-ellipsis",
          title: row.medium
        }, row.medium));
      }
    }, {
      field: 'campaign',
      title: 'Campaign',
      cell: props => {
        var row = props.dataItem;
        return /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
          className: "grid-ellipsis pointer",
          title: row.campaign
        }, row.campaign));
      }
    }, {
      field: 'term',
      title: 'Term',
      sortable: false,
      cell: props => {
        var row = props.dataItem;
        return /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
          className: "grid-ellipsis",
          title: row.term
        }, row.term));
      }
    }, {
      field: 'content',
      title: 'Content',
      cell: props => {
        var row = props.dataItem;
        return /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
          className: "grid-ellipsis",
          title: row.content
        }, row.content));
      }
    }, {
      field: 'users',
      title: 'Users',
      cell: props => {
        var row = props.dataItem;
        return /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
          className: "grid-ellipsis",
          title: row.users
        }, row.users));
      }
    }, {
      field: 'sessions',
      title: 'Sessions',
      cell: props => {
        var row = props.dataItem;
        return /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
          className: "grid-ellipsis",
          title: row.sessions
        }, row.sessions));
      }
    }, {
      field: 'conversions',
      title: 'Conversions',
      cell: props => {
        var row = props.dataItem;
        return /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
          className: "grid-ellipsis",
          title: row.conversions
        }, row.conversions));
      }
    }, {
      field: 'engagements',
      title: 'Engagements',
      cell: props => {
        var row = props.dataItem;
        return /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
          className: "grid-ellipsis",
          title: row.engagements
        }, row.engagements));
      }
    }];
    return /*#__PURE__*/React.createElement(DataGrid, {
      data: data,
      columns: columns,
      pageSize: 10,
      pagination: this.props.pagination,
      onPageRequest: this.props.onPageRequest
    });
  }
}